import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
  variant?: 'primary' | 'secondary';
};
const variants = {
  primary: 'bg-forest text-white hover:bg-forest-dark focus-visible:ring-forest/25',
  secondary: 'bg-espresso text-white hover:bg-cocoa focus-visible:ring-espresso/25'
};
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  variant = 'primary',
  ...props
}: ButtonProps) {
  const classes = `inline-flex items-center justify-center gap-2.5 rounded-full px-6 py-4 text-center text-[13px] font-bold tracking-[0.02em] shadow-lg transition-colors duration-150 focus:outline-none focus-visible:ring-4 sm:px-10 sm:py-[1.125rem] sm:text-lg ${variants[variant]} ${className}`;
  const content = <>
      {showIcon && <ShoppingBagIcon size={20} strokeWidth={2.2} aria-hidden="true" data-id="element-39" data-mp="d3jthjnnhlwd" />}
      {children}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={classes} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} data-id="element-40" data-mp="3bxc15kpyql6">
        {content}
      </motion.a>;
  }
  return <motion.button className={classes} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-41" data-mp="3uizyjjpm48p2">
      {content}
    </motion.button>;
}